import { SeoMapper } from '@search/router/src';

export const windowsDirectionMapper = new SeoMapper('windowsDirectionMapper', {
    BOTH: 'BOTH',
    REAR: 'REAR',
    FRONT: 'FRONT',
    UNKNOWN: 'UNKNOWN'
} as const);
